import React, { useEffect } from "react";
import { FaEye, FaRegHeart } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";
import Rating from "../Rating";
import { Link, useNavigate } from "react-router-dom";
import CurrencyFormat from "../shared/CurrencyFormat";
import {
  add_to_card,
  add_to_wishlist,
  messageClear,
} from "../../store/reducers/cardReducer";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

const ShopProducts = ({ styles, products }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, successMessage } = useSelector((state) => state.card);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const add_card = (id) => {
    if (userInfo) {
      dispatch(
        add_to_card({
          userId: userInfo.id,
          quantity: 1,
          productId: id,
        })
      );
    } else {
      navigate("/login");
    }
  };

  const add_wishlist = (pro) => {
    dispatch(
      add_to_wishlist({
        userId: userInfo.id,
        productId: pro._id,
        name: pro.name,
        price: pro.price,
        image: pro.images[0],
        discount: pro.discount,
        rating: pro.rating,
        slug: pro.slug,
      })
    );
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch]);

  return (
    <div
      className={`w-full grid ${
        styles === "grid"
          ? "grid-cols-2 md-lg:grid-cols-2 md:grid-cols-2 lg:grid-cols-3"
          : "grid-cols-1 md-lg:grid-cols-2 md:grid-cols-2 lg:grid-cols-3"
      } gap-3 `}
    >
      {products.map((p, i) => (
        <div
          key={i}
          className={`border flex transition-all duration-1000 hover:shadow-md hover:-translate-y-3 ${
            styles === "grid"
              ? "flex-col justify-center items-center"
              : "justify-start items-center md:flex-col md:justify-start md:items-start"
          } w-full gap-4 bg-white p-1 rounded-md`}
        >
          <div
            className={
              styles === "grid"
                ? "w-full relative group h-[240px] overflow-hidden" // Changed from h-[210px]
                : "w-7/12 md:w-full relative group h-[240px] md:h-[270px] overflow-hidden" // Changed from h-[210px]
            }
          >
            <img
              className="h-full rounded-md w-full object-contain" // Changed from h-[240px] and object-contain
              src={p.images[0]}
              alt=""
            />

            <ul className="flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
              <li
                onClick={() => add_wishlist(p)}
                className="w-10 h-10 cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-green-600 hover:text-white hover:rotate-[720deg] transition-all"
              >
                <FaRegHeart />
              </li>
              <Link
                to={`/product/details/${p.slug}`}
                className="w-10 h-10 cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-green-600 hover:text-white hover:rotate-[720deg] transition-all"
              >
                <FaEye />
              </Link>
              <li
                onClick={() => add_card(p._id)}
                className="w-10 h-10 cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-green-600 hover:text-white hover:rotate-[720deg] transition-all"
              >
                <RiShoppingCartLine />
              </li>
            </ul>
          </div>

          <div className="flex flex-col justify-center items-center gap-1">
            <h2 className="font-bold">{p.name}</h2>
            <div className="flex justify-start items-center gap-3">
              <span className="text-md font-semibold">
                <CurrencyFormat value={p.price} />
              </span>
            </div>
            <div className="flex mb-2">
              <Rating ratings={p.rating} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShopProducts;
